import { z } from 'zod';

import { Fields, SecretType } from '../constants';
import { basicSecretFormSchema } from './basicSecretFormSchema';

export const secureNoteSecretFormSchema = basicSecretFormSchema.merge(
    z.object({
        [Fields.TYPE]: z.literal(SecretType.SecureNote),
        [Fields.SECURE_NOTE]: z.string().optional(),
    }),
);
